
import React from 'react'
import { ScrollText } from "../scrolltext/ScrollText"
//import UploadedFile from '../promptwithicon/UploadedFile'
import StatusContext from '../../../contexts/StatusContext'

import "./aitest.css"

export const Context = ({ topic, disabled, onChange, attachedFiles, deleteFile }) => {
  
    const {
      changeLanguage,
      //isMe,
    } = React.useContext(StatusContext);
  
  return (
    <div style={{ marginTop: '10px', width: '100%' }}>

       <div style={{fontWeight:'bold', marginBottom:'8px'}}>
        {changeLanguage('aitest', 'showcontext')}:              
      </div>
      
      <ScrollText rows={4} text={topic} disabled={disabled} placeholdertext={changeLanguage('aitest', 'topicplaceholder')} onChange={onChange} />

      {/*
        isMe() &&
        <div className='uploadedFiles flex-container-wrap' style={{width: '100%' }}>
            {
                attachedFiles.map((file, index) => ( 
                  <UploadedFile key={index} filename={file.name} filesize={file.sizeText} deleteFile={() => deleteFile(index)} /> ))
            }
        </div>
      */}
    </div>
  )
}




